




















import Vue from "vue";
import Component from "vue-class-component";

import ImageSelect from "@/components/ImageSelect.vue";
import JudgementResult from "@/components/JudgmentResult.vue";

@Component({
  components: { ImageSelect, JudgementResult }
})
export default class Home extends Vue {
  isSelectedImage: boolean = false;
  imageFile?: File = undefined;
  isProcessing = false;

  imageSelected(imageFile: File) {
    this.isProcessing = true;
    this.imageFile = imageFile;
    this.isSelectedImage = true;
  }

  judgeCompleted() {
    this.isProcessing = false;
  }

  retry() {
    this.isSelectedImage = false;
  }
}
